import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import type { HealthResponse } from "@/types/api";

/** Ping the backend's `/api/health`. Polls every 10s as a liveness signal. */
export function useHealth() {
  return useQuery({
    queryKey: ["health"],
    queryFn: ({ signal }) => apiFetch<HealthResponse>("/api/health", { signal }),
    refetchInterval: 10_000,
    staleTime: 5_000,
  });
}
